module.exports = __webpack_public_path__ + "4bc75694720c16a44ea5bdd8e55f949b.svg";